// Les écrans intégrés à l'assistant des modules (D-158, corrigé le 02/11 : « pourquoi ne pas lui faire faire dans
// l'assistant ?! »). Chaque étape « sur place » dessine l'écran qui existe déjà, dans le cadre de l'assistant, sans le
// recopier : une rubrique de la ⚙ (embedRubric : seulement son contenu) ou l'écran du bureau, sans son « ‹ retour » ni son
// en-tête (assistant.css). Ce qui est saisi s'enregistre tout de suite, le module encore éteint : la base laisse faire le
// bureau pendant l'assistant (_module_setup), rien n'est visible des membres avant l'activation.
import type { EmbedKey } from '../domain/assistant';
import type { Ctx } from './context';
import { embedRubric } from './nav';
import { renderSallesSettings, renderSallesStep } from './salles-gestion';
import { renderImport } from './import-licences';
import { renderPartnerSettings, renderPartnersEmbed } from './partners';
import { renderSubventions } from './subventions';
import { renderClubAgenda } from './club-events';
import { renderPerksAdmin } from './perks';
import { renderMentoringAdmin } from './mentoring';
import { renderFormationSettings } from './formation-reglages';

const rubric = (key: string, render: (el: HTMLElement, c: Ctx) => Promise<void>) => (el: HTMLElement, c: Ctx) => { embedRubric(el, key); return render(el, c); };

export const EMBEDS: Record<EmbedKey, (el: HTMLElement, ctx: Ctx) => Promise<void>> = {
  // Corrigé le 02/11 (2) : d'abord les salles, puis les plages, salle par salle.
  'salles-liste': (el, c) => renderSallesStep(el, c, 'liste'),
  'salles-plages': (el, c) => renderSallesStep(el, c, 'plages'),
  'salles-gestionnaires': rubric('gestionnaires', (el, c) => renderSallesSettings(el, c, c.club!.id)),
  'licences-import': (el, c) => renderImport(el, c, { embedded: true }),
  'partenaires-actuels': (el, c) => renderPartnersEmbed(el, c),
  'partenaires-offre': rubric('offre', (el, c) => renderPartnerSettings(el, c)),
  'subventions-pieces': rubric('pieces', (el, c) => renderSubventions(el, c, ['reglages'])),
  'subventions-chiffres': rubric('chiffres', (el, c) => renderSubventions(el, c, ['reglages'])),
  agenda: (el, c) => renderClubAgenda(el, c),
  avantages: rubric('avantages', (el, c) => renderPerksAdmin(el, c)),
  parrainage: (el, c) => renderMentoringAdmin(el, c),
  'formation-referents': rubric('referents', (el, c) => renderFormationSettings(el, c)),
};
